<template>
	<div>
		<van-collapse v-model="domitory_1" accordion @change="selectThisDor">
			<van-collapse-item v-for="(it, index) in dormitoryFloorList" :key="index" :title="it.dormitoryName" :name="it.dormitoryId">
				<van-collapse v-model="domitory_2" accordion @change="selectThisRoom">
					<van-collapse-item v-for="(item, index) in dormitoryList" :key="index" :title="item.dormRoomName" :name="item.dormRoomId">
						<p class="link-text" @click="navTo(item, 1)">批量录入</p>
						<van-cell size="large" is-link="" v-for="(item_, index) in roomStuList" :key="index" :title="item_.studentName"
						 @click="navTo(item_, 2)" />
					</van-collapse-item>
				</van-collapse>

			</van-collapse-item>
		</van-collapse>

		<bottom-tab></bottom-tab>
	</div>
</template>

<script>
	import Vue from 'vue';
	import api from '../../http/api.js'

	import {
		Toast,
		Collapse,
		CollapseItem,
		Cell
	} from 'vant';

	Vue.use(Collapse);
	Vue.use(CollapseItem);
	Vue.use(Toast);
	Vue.use(Cell);

	export default {
		data() {
			return {
				schoolId: window.localStorage.getItem('scId'),
				dormitoryFloorList: [], //所有宿舍楼
				domitory_1: '',
				domitory_2: '',
				dormitoryList: [], // 选择的宿舍楼中的所有宿舍
				roomStuList: [], // 选择的宿舍成员列表
			}
		},
		methods: {
			pageInit() {
				this.dormitoryFloorList = []
				api.getSchoolDormitory(this.schoolId).then(res => {
					if (res.data.code == 200) {
						for (let i = 0; i < res.data.data.length; i++) {
							this.dormitoryFloorList.push(res.data.data[i])
						}
					} else {
						Toast('获取宿舍楼列表失败' + res.data.msg)
					}
				})
			},
			selectThisDor(val) {
				if (val != '') {
					this.dormitoryList = []
					let data = JSON.stringify({
						columnFilters: {
							dormitoryId: {
								name: "dormitoryId",
								value: val
							}
						},
						pageNum: 1,
						pageSize: 1000
					})
					api.getDormitorRoom(data).then(res => {
						if (res.data.code == 200) {
							for (let i = 0; i < res.data.data.content.length; i++) {
								this.dormitoryList.push(res.data.data.content[i])
							}
						} else {
							Toast('获取宿舍列表失败' + res.data.msg)
						}
					})
				}

			},
			selectThisRoom(val) {
				this.roomStuList = []
				if (val != '') {
					console.log(val);
					api.getStudentsOfDormroom(val).then(res => {
						if (res.data.code == 200) {
							for (let i = 0; i < res.data.data.length; i++) {
								this.roomStuList.push(res.data.data[i])
							}
						} else {
							Toast('获取宿舍成员列表失败' + res.data.msg)
						}
					})
				}

			},
			navTo(it, type) {
				// type为区别 批量 还是 单个
				console.log(it);
				if (type == 1) {
					// 批量
					this.$router.push({
						path: '/classTemp',
						query: {
							id: it.dormRoomId,
							type: 2
						}
					})
				} else {
					// 单个
					this.$router.push({
						path: '/peopleTemp',
						query: {
							id: it.userId
						}
					})
				}
			}
		},
		mounted() {
			// this.pageInit()
		},
		activated() {
			console.log(this.$route.meta.isBack)
			if (!this.$route.meta.isBack) {
				this.dormitoryFloorList = [] //所有宿舍楼
				this.domitory_1 = ''
				this.domitory_2 = ''
				this.dormitoryList = [] // 选择的宿舍楼中的所有宿舍
				this.roomStuList = [] // 选择的宿舍成员列表
				this.pageInit()
			}
		},
		beforeRouteEnter(to, from, next) {
			if (from.name != 'peopleTemp' && from.name != 'classTemp') {
				to.meta.isBack = false;
				// window.location.reload();
			} else {
				to.meta.isBack = true;
			}
			next();
		}
	}
</script>

<style scoped>
	.link-text {
		color: #409EFF;
		margin: 0;
		line-height: 0.9rem;
		text-align: center;
		width: 2rem;
		margin-left: calc(100% - 2rem);
	}
</style>
